export default {"src":"/_next/static/media/pizza.55915972.gif","height":400,"width":400};